Vue.component('card', require('./Card').default);
Vue.component('card-header', require('./CardHeader').default);
Vue.component('card-footer', require('./CardFooter').default);
Vue.component('card-title', require('./CardTitle').default);
Vue.component('card-body', require('./CardBody').default);
Vue.component('card-spinner', require('./CardSpinner').default);
